import { entities } from "@fraction/shared";
import _ from "lodash";
import { ModifiableKeySelect } from "./ModifiableKeySelect";
export const ModifiableKeySelectEnumChoices = ({
  options,
  formatLabel,
  ...props
}: {
  label: string;
  loading?: boolean;
  appId?: string;
  path: string;
  options: string[];
  formatLabel?: ((val: string) => string) | Record<string, string>;
  mutateValueBeforeUpdate?: (val: string) => any;
  formatValue?: (val: string) => any;
  className?: string;
  tooltip?: React.ReactNode;
  defaultValue?: string;
  updateOtherApplicationValuesOnUpdate?: (val: entities.ApplicationT) => Record<string, any>;
}) => {
  const optionsWithLabels = options.map((option) => ({
    value: option,
    label: formatLabel
      ? typeof formatLabel === "function"
        ? formatLabel(option)
        : formatLabel[option]
      : _.startCase(option),
  }));

  return <ModifiableKeySelect {...props} options={optionsWithLabels} />;
};
